import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '../../../services/subscription.service';
import { ModalService } from '../../../services/modals.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { customerServiceView, subscriptionViewSpanish } from '../subscription.static.data';

@Component({
  selector: 'app-subscription-logged-out',
  templateUrl: './subscription-logged-out.component.html',
  styleUrls: ['../../../app.component.css']
})
export class SubscriptionLoggedOutComponent implements OnInit {
  customerServiceView: any;
  subscriptionView: any;

  constructor(public subscriptionService: SubscriptionService, public modalService: ModalService, public googleAnalyticsService: GoogleAnalyticsService) {
    this.customerServiceView = customerServiceView;
    this.subscriptionView = subscriptionViewSpanish;
   }

  ngOnInit() {
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/subscription-logged-out/subscription-logged-out.component.ts